import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-up\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.64645 7.85355C2.84171 8.04882 3.15829 8.04882 3.35355 7.85355L6 5.20711L8.64645 7.85355C8.84171 8.04882 9.15829 8.04882 9.35355 7.85355C9.54882 7.65829 9.54882 7.34171 9.35355 7.14645L6.35355 4.14645C6.15829 3.95118 5.84171 3.95118 5.64645 4.14645L2.64645 7.14645C2.45118 7.34171 2.45118 7.65829 2.64645 7.85355Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol